/**
* Copyright Aquera Inc 2025
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/
import { css } from 'lit';

/**
* Slider CSS
*/
export const styles = css`
  :host {
    display: block;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    height: 100px;
  }

  .align-item-center {
    align-items: center;
  }

  slot.span {
    font-size: var(--nile-font-size-micro);
    margin-top: 14px;
  }

  .range-container {
    display: flex;
    flex-direction: column;
    gap: var(--nile-spacing-sm);
  }

  .column-reverse {
    flex-direction: column-reverse;
  }

  .label-container {
    display: flex;
    justify-content: space-between;
  }

  .label-container span {
    margin: var(--nile-spacing-none);
    padding: var(--nile-spacing-none);
    font-size: var(--nile-font-size-micro);
  }

  .range {
    position: relative;
    width: 228px;
    height: 4px;
    background-color: var(--nile-colors-neutral-400);
    user-select: none;
    border-radius: var(--nile-radius-radius-3xl);
  }

  .range:hover {
    cursor: pointer;
  }

  .range-completed {
    position: absolute;
    height: 100%;
    width: 0%;
    background-color: var(--nile-colors-primary-600);
    top: 0px;
    left: 0px;
    z-index: 98;
    border-radius: var(--nile-radius-radius-3xl);
  }

  .range-button {
    height: 12px;
    width: 12px;
    background-color: var(--nile-colors-primary-600);
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: var(--nile-radius-radius-3xl);
    left: 0;
    z-index: 100;
    box-shadow: rgba(0, 82, 145, 0.1) 0px 1px 2px 0px, rgba(0, 94, 166, 0.15) 0px 0px 0px 2px;
    transition: box-shadow var(--nile-transition-duration-default) ease;
  }

  .range-button:hover, .range-button-two:hover {
    cursor: pointer;
    background-color: var(--nile-colors-primary-700);
  }

  .range-button:active, .range-button-two:active {
    transition: box-shadow var(--nile-transition-duration-default) ease;
    background-color: var(--nile-colors-primary-700);
    box-shadow: rgba(0, 82, 145, 0.1) 0px 1px 2px 0px, rgba(0, 94, 166, 0.15) 0px 0px 0px 4px;
  }

  .range-button-two {
    height: 12px;
    width: 12px;
    background-color: var(--nile-colors-primary-600);
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: var(--nile-radius-radius-3xl);
    left: 100%;
    z-index: 100;
    box-shadow: rgba(0, 82, 145, 0.1) 0px 1px 2px 0px, rgba(0, 94, 166, 0.15) 0px 0px 0px 2px;
    transition: box-shadow var(--nile-transition-duration-default) ease;
  }
`;

export default [styles];
